import { motion } from "framer-motion";

const pieces = [
  {
    id: "peapods",
    img: "/photos/sidepiece-peapods.webp",
    alt: "Crochet pea pod with three little green peas, made by Els",
    name: "The Pea Pod Trio",
    note: "three peas, zero chores",
  },
  {
    id: "coaster",
    img: "/photos/sidepiece-coaster.webp",
    alt: "Crochet flower coaster in cream, mustard and green, made by Els",
    name: "The Sunny Coaster",
    note: "blooms under every mug",
  },
];

const SidePieces = () => (
  <section id="side-pieces" className="py-28 sm:py-36" data-testid="side-pieces-section">
    <div className="max-w-6xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-16 text-center"
      >
        <p className="font-hand text-2xl text-[#C27F67] -rotate-2 mb-2">not for sale — just smiles</p>
        <h2 className="font-heading font-medium tracking-tight text-3xl sm:text-4xl text-[#2C402B]">
          Little side pieces
        </h2>
        <p className="mt-4 text-base text-[#576956] max-w-lg mx-auto leading-relaxed">
          When Els isn't stitching orders, she crochets tiny treasures just for
          the joy of it. These cuties aren't for sale — they're simply here to
          make you smile.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 gap-10 lg:gap-14 max-w-3xl mx-auto">
        {pieces.map((piece, i) => (
          <motion.figure
            key={piece.id}
            initial={{ opacity: 0, y: 40, rotate: i === 0 ? -3 : 3 }}
            whileInView={{ opacity: 1, y: 0, rotate: i === 0 ? -2 : 2 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ rotate: 0, scale: 1.03 }}
            className="group bg-white rounded-[2rem] border border-[#D3D7CF] shadow-[0_8px_30px_rgba(44,64,43,0.08)] p-4 pb-6"
            data-testid={`side-piece-${piece.id}`}
          >
            <div className="rounded-3xl overflow-hidden">
              <img
                src={piece.img}
                alt={piece.alt}
                className="w-full h-64 sm:h-72 object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                data-testid={`side-piece-${piece.id}-image`}
              />
            </div>
            <figcaption className="mt-5 text-center">
              <p className="font-heading font-medium text-lg text-[#2C402B]">{piece.name}</p>
              <p className="font-hand text-xl text-[#A67C52] -rotate-1 mt-0.5">{piece.note}</p>
              <span className="inline-block mt-3 bg-[#E8EAE3] rounded-full px-4 py-1 text-xs font-semibold text-[#576956] uppercase tracking-wider" data-testid={`side-piece-${piece.id}-badge`}>
                just for show
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default SidePieces;
